import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import { HomeOutlined } from "@mui/icons-material";
import { Box, Button, CircularProgress, Grid } from '@mui/material';
import { getObjectListByPropertyApi } from 'api/general';
import MeetingTitleBox from 'app/components/Box/MeetingTitleBox';
import PreviousStatusCard from 'app/components/Card/PreviousStatusCard';
import ReviewStatusCard from 'app/components/Card/ReviewStatusCard';
import VoteStatusCard from 'app/components/Card/VoteStatusCard';
import LoadingPopUp from "app/components/LoadingPopup";
import VisiblePageRow from "app/components/VisiblePageRow";
import { chunkData, sortByProperty } from 'app/utils/appHelpers';
import { DECISION, DECISION_FILE, MEETING_USER, REVIEWS, STATUS_REVIEW, VOTE } from 'app/utils/constants/customConstant';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { setCurrentMeeting, setCurrentMeetingUsers } from "stores/meeting";

const PreviousPage = () => {
    const params = useParams();
    const param = params.page

    const navigate = useNavigate();
    const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar();

    const userList = useSelector(state => state.user.data || []);
    const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
    const [loading, setLoading] = useState(false);
    const [decisionsOfTheMeeting, setDecisionsOfTheMeeting] = useState([]);
    const [votesOfTheMeeting, setVotesOfTheMeeting] = useState([]);
    const [reviewsOfTheMeeting, setReviewsOfTheMeeting] = useState([]);
    const [dstatusOfTheMeeting, setDstatusOfTheMeeting] = useState([]);

    const [decisionFileOfTheMeeting, setDecisionFileOfTheMeeting] = useState([]);

    const dispatch = useDispatch();
    useEffect(() => {
        const getAPI = async () => {

            setLoading(true);
            try {
                const [res, res2, res3, res4, res5, res6] = await Promise.all([
                    getObjectListByPropertyApi(DECISION, "meetingId", currentMeeting.id),
                    getObjectListByPropertyApi(REVIEWS, "meetingId", currentMeeting.id),
                    getObjectListByPropertyApi(VOTE, "meetingId", currentMeeting.id),
                    getObjectListByPropertyApi(STATUS_REVIEW, "meetingId", currentMeeting.id),
                    getObjectListByPropertyApi(DECISION_FILE, "meetingId", currentMeeting.id),
                    getObjectListByPropertyApi(MEETING_USER, "meetingId", currentMeeting.id)
                ]);
                setDecisionsOfTheMeeting(sortByProperty(res.data, "decisionNo"))
                setReviewsOfTheMeeting(res2.data)
                setVotesOfTheMeeting(res3.data);
                setDstatusOfTheMeeting(res4.data);
                setDecisionFileOfTheMeeting(res5.data);

                let data = res6.data.filter(item => item.type === 1)
                data = sortByProperty(data, "indexNo")
                dispatch(setCurrentMeetingUsers(data));


            } catch (error) {
                console.error("Hata:", error);
            } finally {
                setLoading(false);
            }
        };
        getAPI();
    }, [currentMeeting.id]);



    const handleHomeClick = () => {


        dispatch(setCurrentMeetingUsers([]))
        dispatch(setCurrentMeeting({}))
        if (param === 'watching') {
            navigate("/watchingMeetingPage")
        } else {

            navigate("/")
        }
        setSidebarOptions({ open: true })
    }


    return (
        <React.Fragment>

            <LoadingPopUp open={loading} />

            {!loading && (
                <>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', flexDirection: 'column', gap: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <MeetingTitleBox
                                meeting={currentMeeting}
                                type="dashboard"
                            />
                            <Button onClick={() => handleHomeClick()} startIcon={<HomeOutlined />} sx={{ ml: 'auto', whiteSpace: 'nowrap' }}>
                                {param === 'watching' ? 'Liste' : 'Ana Sayfa'}
                            </Button>
                        </Box>



                    </Box>
                    {currentMeeting.statFinish === 0 && currentMeeting.statVideoCall === 1 && (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', mt: 2 }}>

                            <Button
                                component="a"
                                sx={{ mb: 2 }}
                                href={currentMeeting.meetingUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                variant="contained"
                                color="primary"
                            >
                                Toplantıya katılmak için tıklayınız
                            </Button>

                        </Box>
                    )}




                    {
                        decisionsOfTheMeeting !== null &&
                        decisionsOfTheMeeting.map((decision, index) => {


                            let voteFilteredList = votesOfTheMeeting.filter(
                                (item) => item.decisionId === decision.id
                            );

                            voteFilteredList.forEach((element) => {
                                const user = userList.find(
                                    (item) => item.id === element.userId
                                );
                                element.user = user;
                            });

                            let reviewFilteredList = reviewsOfTheMeeting.filter(
                                (item) => item.decisionId === decision.id
                            );



                            let dstatusFilteredList = dstatusOfTheMeeting.filter(
                                (item) => item.decisionId === Number(decision.id)
                            );

                            let filedata = decisionFileOfTheMeeting.filter(
                                (item) => item.decisionId === decision.id
                            );


                            let agendaFiles = filedata.filter(item => item.fileInfo === null || item.fileInfo === "")
                            agendaFiles.forEach(element => {
                                const user = userList.find(item => item.id === element.adminUserId);
                                element.user = user;
                            });

                            let links = [];
                            links = filedata.filter(item => item.fileInfo !== "" && item.ext === "")


                            let groupedData = chunkData(agendaFiles, 5);
                            let groupedDataLink = chunkData(links, 5);

                            return (
                                <VisiblePageRow key={decision.id}>
                                <Grid container spacing={1} sx={{ marginBottom: 1 }}>

                                    <Grid item xs={12} md={8} lg={8}>
                                        <PreviousStatusCard
                                            decision={decision}
                                            index={index}
                                            reviewsOfTheMeeting={reviewFilteredList}
                                            votesOfTheMeeting={voteFilteredList}
                                            dstatusOfTheDecision={dstatusFilteredList}
                                            groupedData={groupedData}
                                            groupedDataLink={groupedDataLink}
                                        />
                                    </Grid>


                                    <Grid item xs={12} md={4} lg={4}>
                                        <VoteStatusCard
                                            scroll={false}
                                            votesOfTheMeeting={voteFilteredList}
                                        />
                                    </Grid>


                                </Grid>
                                </VisiblePageRow>
                            );
                        })
                    }


                </>
            )}
        </React.Fragment>
    );
};

export default PreviousPage;
